import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * `requireRole` is a single role code (e.g. "P-SA") this route requires
 * via useAuth().hasRole(). Mirrors tis-spa-talent's ProtectedRoute, with
 * a role-code check instead of a legacy string-role check since this app
 * reads real Auth-platform role grants from the JWT, not a Mongo
 * document's own `role` field.
 */
export default function ProtectedRoute({ children, requireRole }) {
  const { user, loading, hasRole } = useAuth();

  if (loading || user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireRole && !hasRole(requireRole)) return <Navigate to="/" replace />;
  return children;
}
